/**
 * @generated SignedSource<<cb6ecbc4b32720b667c51ced79d110df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PackageOrderFooterQuery$variables = {
  memberPackageId: string;
  orderId: string;
};
export type PackageOrderFooterQuery$data = {
  readonly memberPackage: {
    readonly package?: {
      readonly displayInApp: {
        readonly termsAndConditionsUrl: string | null | undefined;
      } | null | undefined;
    };
    readonly squareCard?: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly order: {
    readonly id?: string;
    readonly total?: number | null | undefined;
  } | null | undefined;
};
export type PackageOrderFooterQuery = {
  response: PackageOrderFooterQuery$data;
  variables: PackageOrderFooterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberPackageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "memberPackageId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareCardOnFile",
  "kind": "LinkedField",
  "name": "squareCard",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "DisplayInApp",
  "kind": "LinkedField",
  "name": "displayInApp",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termsAndConditionsUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orderId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageOrderFooterQuery",
    "selections": [
      {
        "alias": "memberPackage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "order",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/)
            ],
            "type": "Order",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PackageOrderFooterQuery",
    "selections": [
      {
        "alias": "memberPackage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "order",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/)
            ],
            "type": "Order",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68076b80afab000442a2075145b061ad",
    "id": null,
    "metadata": {},
    "name": "PackageOrderFooterQuery",
    "operationKind": "query",
    "text": "query PackageOrderFooterQuery(\n  $memberPackageId: ID!\n  $orderId: ID!\n) {\n  memberPackage: node(id: $memberPackageId) {\n    __typename\n    ... on MemberPackage {\n      squareCard {\n        id\n      }\n      package {\n        __typename\n        displayInApp {\n          termsAndConditionsUrl\n        }\n        id\n      }\n    }\n    id\n  }\n  order: node(id: $orderId) {\n    __typename\n    ... on Order {\n      id\n      total\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "430671f67c2ae992d048fe7f59983198";

export default node;
